var map = {
	"./Building-Blocks-Logo-1.png": "740d",
	"./bb-image.jpg": "30f2",
	"./bb-image.svg": "b6b7",
	"./brand-left-circle.png": "af35",
	"./brand-left-circle.svg": "a6f8",
	"./brand-right-shapes.png": "250f",
	"./brand-right-shapes.svg": "7287",
	"./brickwall.png": "4ea7",
	"./icon-come-back.svg": "fd56",
	"./icon-complete-app.svg": "3c90",
	"./icon-description.svg": "23ae",
	"./icon-edit.svg": "0f2f",
	"./icon-email.svg": "19d0",
	"./icon-generic-error.png": "4b7f",
	"./icon-lock.svg": "85d1",
	"./icon-phone.svg": "6ab6",
	"./icon-question.svg": "9732",
	"./icon-temporary-residents.svg": "02fa",
	"./icon-timeout.png": "07bc",
	"./icon-what-happens.svg": "3ce5",
	"./icon-whats-online.png": "9a3d",
	"./icon-whats-online.svg": "e99d",
	"./in-progress-application.svg": "6f3c",
	"./logo-bk.svg": "9d57",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";